// Shared motion presets used across booking steps and other animated sections.
// Hoisting these to module scope keeps Framer Motion from seeing fresh object identities
// on every render (which would otherwise re-trigger animations unnecessarily).

export const STEP_MOTION = {
  initial: { opacity: 0, x: 24 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -24 },
  transition: { duration: 0.25 },
};

export const FADE_UP_MOTION = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
};

export const CARD_HOVER = { y: -4 };
